import React, { useState, useEffect } from 'react';
import PageContainer from '../components/containers/PageContainer';
import { Card, CardHeader, CardContent, IconButton, TableCell, TableRow, Tooltip, Stack, Button } from '@mui/material';
import { toast } from 'react-toastify';
import Field from '../components/ui/Field';
import CustomTable from '../components/ui/CustomTable';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ModalContainer from '../components/containers/ModalContainer';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../config/axios';

const CustomPricing = () => {
    const { id } = useParams();
    const [pricing, setPricing] = useState([]);
    const [userPricing, setUserPricing] = useState({});
    const [message, setMessage] = useState('');
    const [loader, setLoader] = useState('');
    const [labelType, setlabelType] = useState('');
    const [singleWeight, setSingleWeight] = useState({});
    const navigate = useNavigate();

    const [showAddPricing, setShowAddPricing] = useState(false);

    const onCloseAddPricingModal = () => {
        setShowAddPricing(false);
    };
    const onOpenAddPricingModal = () => setShowAddPricing(true);

    const [showEditPricing, setShowEditPricing] = useState(false);

    const onCloseEditPricingModal = () => {
        setShowEditPricing(false);
    };
    const onOpenEditPricingModal = () => setShowEditPricing(true);

    const getUserPricing = async () => {
        await api
            .get('/admin/user/read/' + id)
            .then((res) => {
                setUserPricing(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    useEffect(() => {
        getUserPricing();
    }, [id]);

    const getPricing = async () => {
        await api
            .get('/labeltype/read')
            .then((res) => {
                setPricing(res.data.labelTypes);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    useEffect(() => {
        getPricing();
    }, []);

    const addWeight = async (e) => {
        e.preventDefault();

        setLoader(true);

        const data = {
            fromWeight: e.target.fromWeight.value,
            toWeight: e.target.toWeight.value,
            price: e.target.price.value,
            labelType: labelType,
        };

        await api
            .put('/admin/user/custom-pricing/' + id, data)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getUserPricing();
                onCloseAddPricingModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };

    const deleteWeight = async (index) => {
        const data = {
            index,
        };

        await api
            .post('/admin/user/custom-pricing/delete/' + id, data)
            .then((res) => {
                toast.success(res.data.message);
                getUserPricing();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };

    const updateWeight = async (e) => {
        e.preventDefault();

        setLoader(true);

        const data = {
            price_id: singleWeight._id,
            fromWeight: e.target.fromWeight.value,
            toWeight: e.target.toWeight.value,
            price: e.target.price.value,
            premiumPrice: e.target.premium.value,
            originalPrice: e.target.originalPrice.value,
        };

        await api
            .put('/labeltype/updateWeight/' + id, data)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getPricing();
                onCloseEditPricingModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };

    console.log(labelType);
    return (
        <PageContainer
            title="Add Custom Pricing"
            end={
                <Button onClick={onOpenAddPricingModal} variant="contained">
                    Add Label Pricing
                </Button>
            }>
            <CustomTable
                sx={{ mt: 2 }}
                fields={['#', 'LABEL TYPE', 'FROM WEIGHT', 'TO WEIGHT', 'PRICE', 'ACTION']}
                dense={false}>
                {userPricing?.customPricing?.map((price, index) => (
                    <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{price.labelType}</TableCell>
                        <TableCell>{price.fromWeight}</TableCell>
                        <TableCell>{price.toWeight}</TableCell>
                        <TableCell>${price.price}</TableCell>
                        <TableCell>
                            <Stack direction="row">
                                <IconButton color="error" onClick={() => deleteWeight(index)}>
                                    <DeleteOutlineOutlinedIcon fontSize="small" />
                                </IconButton>
                            </Stack>
                        </TableCell>
                    </TableRow>
                ))}
            </CustomTable>
            {/* create Pricing */}

            <ModalContainer
                open={showAddPricing}
                onClose={onCloseAddPricingModal}
                title="Add Label Pricing"
                hideActions>
                {message}
                <form onSubmit={addWeight}>
                    <div className="form-group mb-3">
                        <label>Type</label>
                        <select
                            name="labelType "
                            id=""
                            className="form-control form-control-sm"
                            onChange={(e) => setlabelType(e.target.value)}>
                            <option value="" disabled selected hidden>
                                select
                            </option>
                            {pricing?.map((e) => (
                                <option value={e.name} key={e._id}>
                                    {e.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group mb-3">
                        <label>From Weight</label>
                        <input type="tel" className="form-control form-control-sm" name="fromWeight" required />
                    </div>
                    <div className="form-group mb-3">
                        <label>To Weight</label>
                        <input type="tel" className="form-control form-control-sm" name="toWeight" required />
                    </div>

                    <div className="form-group mb-3">
                        <label>Price</label>
                        <input type="tel" className="form-control form-control-sm" name="price" required />
                    </div>

                    <div className="d-flex mt-2 justify-content-between ">
                        <button type="button" className="btn btn-warning btn-sm me-3" data-bs-dismiss="modal">
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary btn-sm">
                            Add {loader}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* Edit Pricing */}
            <ModalContainer open={showEditPricing} onClose={onCloseEditPricingModal} hideActions title="Edit weight">
                {message}
                <form onSubmit={updateWeight}>
                    <div className="form-group mb-3">
                        <label>From Weight</label>
                        <input
                            type="number"
                            className="form-control"
                            name="fromWeight"
                            required
                            defaultValue={singleWeight.fromWeight}
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label>To Weight</label>
                        <input
                            type="number"
                            className="form-control"
                            name="toWeight"
                            required
                            defaultValue={singleWeight.toWeight}
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label>Original Price</label>
                        <input
                            type="tel"
                            className="form-control"
                            name="originalPrice"
                            required
                            defaultValue={singleWeight.originalPrice}
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label>Price</label>
                        <input
                            type="tel"
                            className="form-control"
                            name="price"
                            defaultValue={singleWeight.price}
                            required
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label>Premium Price</label>
                        <input
                            type="tel"
                            className="form-control"
                            name="premium"
                            required
                            defaultValue={singleWeight.premiumPrice}
                        />
                    </div>
                    <div className="d-flex mt-2 justify-content-end ">
                        <button type="button" className="btn btn-white me-3" data-bs-dismiss="modal">
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary">
                            Update {loader}
                        </button>
                    </div>
                </form>
            </ModalContainer>
        </PageContainer>
    );
};

export default CustomPricing;
